<template>
  <div class="bx-custom-cart cart-widget">
    <span class="account">

      <DropdownMenu
        :show-dropdown="showDropdown"
        :right="true"
        :hover="false"
        :interactive="true"
        @update-show-dropdown="showDropdown = $event">
        <template #default>
          <a class="icon acount__icon dropdown-toggle"
             src="#">
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="14"
                 height="24"
                 viewBox="0 0 14 24">
              <g fill="current"
                 fill-rule="evenodd">
                <path stroke="#FFF"
                      stroke-width=".5"
                      d="M.081 16.942c.09 0 .163-.028.222-.083.017-.016.035-.04.035-.058.001-.124.022-.25-.063-.363-.053-.193-.107-.364-.133-.539-.051-.353-.1-.706-.124-1.061-.024-.332-.018-.666-.015-1 .001-.146.025-.292.046-.438.008-.06.037-.116.053-.175.045-.164.097-.328.13-.495.06-.296.19-.575.338-.841.184-.329.355-.665.588-.972.132-.174.252-.354.386-.527.068-.086.155-.162.236-.241.325-.319.64-.649 1.029-.91.297-.2.621-.372.944-.542.19-.1.399-.174.601-.259.177-.074.353-.148.533-.218.071-.028.15-.04.223-.067.093-.034.179-.08.272-.113.146-.049.3-.054.454-.048.021 0 .047.005.063-.003.115-.058.24-.038.361-.035.17.006.34.026.511.037a.854.854 0 0 0 .144 0c.226-.023.446.014.667.05.283.045.542.147.806.239.123.042.248.08.369.124.208.079.428.144.619.247.24.13.479.263.682.44.076.066.178.116.265.18.168.12.333.243.467.395.052.06.124.107.182.162.059.056.113.115.168.174.138.146.277.291.413.438.041.044.075.092.112.138.01.013.013.029.024.04.1.116.21.227.3.349.129.175.245.357.362.538.068.105.132.212.193.32.191.34.317.702.435 1.064.064.198.13.396.198.593.087.256.176.511.265.767.045.13.092.259.133.39.013.039.007.082.016.123.018.08.048.16.059.242.018.143.026.288.04.432.016.174.039.347.05.52.006.082.015.167-.035.245-.016.024-.005.06-.012.089-.034.143-.073.285-.104.428-.024.11-.033.224-.058.335-.031.143-.075.284-.108.426-.032.132-.052.265-.087.396-.037.143-.062.293-.135.422-.064.114-.12.233-.195.341a6.706 6.706 0 0 1-.237.31c-.093.118-.207.225-.282.349-.075.124-.177.23-.257.35a.51.51 0 0 1-.208.178c-.09.043-.19.098-.24.195-.034.066-.1.12-.154.18-.051.056-.116.105-.157.166-.072.11-.212.153-.304.243-.06.06-.122.119-.19.172-.261.206-.523.412-.79.614-.19.144-.383.288-.583.422-.165.112-.342.21-.513.316-.054.032-.102.075-.161.096a.987.987 0 0 0-.18.085c-.047.028-.104.044-.156.065-.111.045-.227.083-.331.136-.293.15-.617.235-.93.341-.086.029-.177.046-.266.066-.017.003-.037-.005-.062-.029.234-.093.468-.186.684-.27l.042-.141c-.148.074-.317.094-.409.228-.061.088-.178.078-.271.079a.497.497 0 0 0-.184.032c-.229.088-.457.177-.687.262-.085.03-.171.069-.302.045l.211-.09c.292-.122.587-.24.848-.41.068-.043.07-.046.098-.111-.054-.04-.098-.001-.144.016-.263.096-.525.192-.797.27.066-.027.132-.056.2-.083.023-.01.052-.013.072-.027.016-.011.023-.034.034-.051-.024-.01-.051-.033-.072-.03a2.805 2.805 0 0 0-.241.054c-.252.064-.503.126-.753.195-.201.055-.399.118-.598.177-.016.005-.032.008-.061.014-.001-.054.023-.08.073-.096.18-.06.36-.117.537-.182.21-.077.417-.16.622-.245a.366.366 0 0 0 .181-.157c-.124-.028-.2.108-.318.059l-.307.1c-.106.034-.211.069-.32.096.126-.1.286-.14.452-.196-.108-.038-.117-.033-.465.044-.144.031-.296.038-.448.05.046-.016.092-.035.14-.048.276-.078.552-.153.828-.232a1.3 1.3 0 0 0 .226-.089c.201-.102.4-.208.597-.314.047-.025.089-.058.133-.087a.21.21 0 0 0-.139.008c-.153.065-.304.136-.457.201-.062.026-.119.075-.218.048.028-.025.044-.045.066-.058.097-.06.197-.114.294-.174.027-.018.044-.047.077-.082-.114-.023-.173.042-.268.068.085-.049.15-.086.215-.125.129-.078.256-.158.386-.236.046-.027.06-.06.046-.12l-.731.257c.096-.061.196-.118.303-.161.513-.205.984-.474 1.467-.724.2-.103.403-.204.589-.323.282-.183.545-.386.75-.635.09-.11.172-.226.26-.338.016-.021.042-.037.062-.057.025-.024.056-.048.073-.077.076-.123.134-.256.226-.368.07-.086.109-.18.167-.269.06-.091.114-.186.168-.28.07-.12.143-.237.204-.358.24-.48.482-.966.548-1.49a4.02 4.02 0 0 0-.048-1.38 5.858 5.858 0 0 0-.417-1.254c-.074-.157-.17-.307-.253-.461a1.845 1.845 0 0 1-.118-.252.544.544 0 0 0-.229-.308c-.033-.02-.054-.058-.076-.089-.141-.2-.279-.4-.424-.599a2.994 2.994 0 0 0-.586-.595c-.31-.241-.615-.488-.94-.714-.395-.275-.869-.41-1.362-.493a1.155 1.155 0 0 0-.716.096c-.06.03-.14.036-.184.076-.047.042-.096.08-.148.117-.158.113-.317.226-.474.341-.026.02-.043.047-.065.07-.15.153-.295.309-.448.458-.182.178-.321.378-.435.591-.102.189-.199.379-.29.57a1.28 1.28 0 0 0-.132.64v.09c-.001.113-.013.227.052.333.016.026.019.058.023.088.024.18.05.36.068.54.017.157.018.316.04.473.024.179.059.354.184.512.073.094.098.216.146.325.102.23.202.459.308.686.084.178.175.353.264.53.112.221.203.453.34.663.212.326.351.676.529 1.013.082.157.118.332.173.5.036.108.07.217.103.327.007.026-.002.055 0 .082.001.03-.004.065.012.088.049.068.11.13.16.197a.158.158 0 0 1 .03.084.724.724 0 0 0 .127.353c.068.108.06.249-.039.312a.468.468 0 0 1-.236.083c-.171-.003-.325-.057-.409-.203a.182.182 0 0 0-.046-.05c-.056-.042-.115-.08-.17-.123-.067-.052-.132-.043-.166.028-.018.038-.028.08-.039.12-.013.05-.044.083-.106.085l-.426.016c-.028.022-.076.066-.131.103-.085.057-.176.08-.275.022-.02-.012-.05-.016-.075-.019a.398.398 0 0 1-.232-.098c-.04-.037-.088-.053-.142-.03-.045.02-.077.005-.106-.02-.057-.047-.117-.093-.165-.147a2.217 2.217 0 0 0-.475-.372c-.032-.02-.088-.01-.128-.014-.054-.069-.102-.143-.165-.207a.816.816 0 0 0-.182-.134.265.265 0 0 0-.127-.02c-.104.002-.104.005-.13-.082a.18.18 0 0 0-.124-.046" />
                <path d="M10.324 10.079c-.07-.018-1-.784-1.07-.801.002-.006.006-.011.01-.017a.247.247 0 0 1 .073-.076l.157-.125c.023-.02.052-.038.06-.064.019-.065.075-.103.123-.148.04-.037.082-.072.12-.11a.187.187 0 0 0 .05-.07c.015-.052.053-.089.088-.129.032-.034.077-.064.089-.107.018-.069.067-.118.111-.172.015-.018.036-.035.037-.057.008-.09.077-.149.131-.218a.21.21 0 0 0 .055-.12c.002-.028.018-.052.03-.077s.038-.047.038-.074c0-.07.046-.121.076-.18.018-.034.04-.068.042-.106.003-.129.104-.271.148-.396.05-.143.092-.288.127-.433.067-.286.108-.576.133-.866.038-.446.087-.928-.028-1.366-.024-.084-.05-.166-.04-.256.004-.046-.035-.091-.035-.138a.656.656 0 0 0-.07-.28c-.028-.057-.001-.126-.041-.183a.363.363 0 0 1-.054-.16c-.004-.034-.026-.067-.044-.1-.032-.057-.067-.111-.082-.177-.01-.048-.047-.091-.077-.134-.052-.075-.118-.142-.142-.231-.01-.033-.047-.062-.069-.093-.023-.032-.05-.063-.065-.096a.443.443 0 0 0-.117-.15 26.97 26.97 0 0 0-.14-.126.535.535 0 0 1-.119-.141c-.015-.026-.05-.046-.079-.067-.083-.064-.17-.122-.24-.202-.044-.05-.123-.081-.186-.118-.072-.043-.15-.079-.21-.136-.033-.03-.08-.052-.124-.072a3.005 3.005 0 0 0-.122-.053l-.125-.045c-.1-.037-.204-.062-.29-.122-.036-.026-.09-.034-.136-.047-.104-.028-.21-.047-.315-.07-.057-.012-.117-.021-.167-.043a.345.345 0 0 0-.197-.033c-.06.009-.11-.029-.169-.034a1.466 1.466 0 0 1-.347-.048C7.07.996 7.005 1 6.944 1.002a5.43 5.43 0 0 0-.63.042c-.059.006-.123.02-.18.015-.125-.014-.245.014-.364.042a3.749 3.749 0 0 0-.33.092c-.079.029-.152.06-.24.104-.085.015-.2.036-.308.062-.108.054-.233.115-.354.18-.056.033-.11.069-.169.098-.05.024-.104.04-.15.059-.023.025-.04.043-.06.067-.046.02-.099.042-.146.07-.048.027-.09.062-.133.095l-.07.053-.064.057-.129.115a3.065 3.065 0 0 0-.238.237.958.958 0 0 1-.19.173.398.398 0 0 0-.154.192c-.01.02-.018.046-.036.06-.08.067-.123.153-.176.233-.036.062-.069.123-.13.171-.058.044-.078.104-.104.16-.119.235-.2.475-.271.714-.022.077-.038.155-.094.224-.023.028-.029.067-.038.102-.013.063-.024.127-.034.19-.007.042-.013.085-.025.125-.008.032-.027.062-.04.092l.07.097-.09.106c-.005.014-.013.027-.014.042-.009.086-.009.175-.012.262-.004.073.003.145-.029.218-.016.04-.013.086-.01.13.007.089.016.177.03.265a.486.486 0 0 1-.004.198c.018.034.034.067.058.106-.004.047-.013.099-.008.15.006.058.025.116.044.174l.063.194c.01.029.026.06.022.087a.491.491 0 0 0 .07.26c.044.098.098.193.107.3.003.035.03.071.05.105.046.09.107.174.162.261.037.06.075.118.096.184a.45.45 0 0 0 .086.152c.04.044.09.083.146.115.037.062.07.125.115.179.061.074.14.14.167.228.051.053.101.105.154.157.077.073.168.134.213.227.016.034.055.06.085.083l.105.084a.324.324 0 0 1-.143.075l-1.115.814m2.178-4.236c.029-.053.014-.102.009-.153l-.014-.096-.006-.098c-.004-.043-.007-.086.028-.128.018-.023.015-.05.014-.077 0-.045.007-.09.008-.137.002-.023.002-.044.005-.07l.008-.079c.006-.041.013-.082.048-.118.021-.022.024-.05.03-.076.017-.079.033-.157.054-.234.02-.054.024-.113.086-.154.026-.017.028-.045.037-.07.014-.043.035-.083.052-.124l.027-.062.031-.06c.012-.021.02-.048.046-.061.06-.03.081-.07.106-.114.023-.042.055-.076.081-.115l.041-.057.047-.052c.027-.03.05-.062.101-.074.034-.007.053-.029.072-.048.035-.033.068-.068.107-.096.038-.03.073-.063.113-.091a.215.215 0 0 1 .11-.04c.029-.001.05-.016.07-.03.066-.032.136-.073.198-.105.017-.008.033-.017.05-.023a.117.117 0 0 1 .069.003c.02.008.04-.004.058-.01.058-.02.127-.037.198-.05.021-.006.047-.013.07-.002.048.023.095.016.142.01.053-.002.106-.01.16-.007.024 0 .05 0 .072.014.033.024.07.024.105.028.032.003.066.003.097.01.016.001.035 0 .046.011a.155.155 0 0 0 .076.043c.028.006.057.009.084.015.056.012.108.025.16.039.029.01.062.016.071.048.004.013.014.02.025.025.037.02.088.027.095.083.028.015.055.033.083.051.032.018.066.04.072.08.001.018.018.028.031.04.025.018.051.039.076.06.01.01.029.016.03.032.002.072.066.11.108.163.007.009.018.017.017.029a.119.119 0 0 0 .02.082c.015.024.037.044.053.069.024.035.052.068.041.117-.004.023.015.042.026.063.056.091.106.179.148.284.016.042.044.082.017.132-.008.017-.002.034.002.05l.035.093.025.096c.005.029.057.05.042.081-.015.03-.008.058-.003.087.002.012.007.026-.001.037-.044.063-.026.124-.015.185.01.093.015.186.016.28-.02.042-.04.083-.013.13.006.01 0 .02-.005.03-.01.023-.024.044-.017.069.008.025-.043.039-.053.06a.052.052 0 0 0-.005.011h-.003c-.006-.002-.017.01-.022.017-.003.005 0 .011.008.015-.018.036-.036.072-.06.105-.007.011-.015.024-.009.038l.003.012c-.036.015-.036.017-.002.04-.007.017-.019.034-.029.051l-.037.06c-.013.019-.029.037-.043.056-.03.037-.058.073-.085.11-.013.017-.03.033-.025.054.01.04-.019.067-.042.096-.033.04-.076.074-.062.13.002.011-.01.018-.016.026-.04.047-.102.083-.093.151.001.014-.017.022-.027.031-.025.022-.05.043-.072.065-.012.012-.029.024-.027.042.007.044-.029.067-.06.093l-.082.071a.086.086 0 0 1-.025.069c-.018.017-.042.03-.061.047-.012.01-.022.02-.023.036-.001.036-.03.055-.06.075-.045.033-.1.06-.148.094-.049.032-.107.054-.12.116-.002.016-.022.021-.035.03l-.083.049c-.03.018-.06.037-.075.072-.008.021-.03.034-.053.046-.047.026-.094.05-.144.075-.047.021-.097.038-.116.088-.009.024-.038.03-.06.043-.075.035-.155.066-.23.1-.024.01-.054.017-.066.04a.118.118 0 0 1-.045.048c-.053-.065-.133-.094-.2-.13-.065-.035-.129-.063-.157-.125-.009-.021-.036-.031-.056-.045-.055-.035-.11-.069-.166-.108-.02-.015-.047-.03-.055-.053-.02-.06-.08-.097-.13-.138a20.2 20.2 0 0 1-.154-.125c-.037-.033-.073-.067-.084-.116-.007-.026-.032-.046-.05-.068-.05-.053-.107-.101-.149-.158a.136.136 0 0 1-.035-.073c-.006-.06-.049-.095-.118-.122-.01-.03-.009-.063-.024-.09-.016-.027-.048-.047-.076-.072a.295.295 0 0 1-.006-.065c0-.022.004-.045.008-.075a1.093 1.093 0 0 1-.068-.117c-.02-.041-.046-.081-.063-.124-.016-.037-.034-.072-.018-.114.015-.033-.001-.06-.012-.089-.03-.077-.05-.157-.072-.236-.005-.025-.017-.052-.003-.077" />
              </g>
            </svg>
          </a>
        </template>

        <template #dropdown>
          <span>
            <span class="dropdown-heading text-large">Mein Konto</span>
            <div class="dropdown-user">
              <div><a class="btn"
                      :href="getURLFromBase('/account/login')">Anmelden</a></div>
              <div class="dropdown-register-wrapper"> oder <a class="dropdown-register"
                                                              href="https://www.happinez.de/account/login">Registrieren</a></div>
            </div>
            <ul class="dropdown-list">
              <li class="list-item"><a :href="getURLFromBase('/account')">&Uuml;bersicht</a></li>
              <li class="list-item"><a :href="getURLFromBase('/account/profile')">Per&ouml;nliches Profil</a></li>
              <li class="list-item"><a :href="getURLFromBase('/account/address')">Adressen</a></li>
              <li class="list-item"><a :href="getURLFromBase('/account/payment')">Zahlungsarten</a></li>
              <li class="list-item"><a :href="getURLFromBase('/account/order')">Bestellungen</a></li>
            </ul>
          </span>
        </template>
      </DropdownMenu>
    </span>

    <a class="cart"
       src="#"
       @click="showSidebar = !showSidebar">
      <span class="icon cart__icon">
        <svg xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink"
             width="18"
             height="23">
          <defs>
            <path id="bag-a"
                  d="M15.448 18.306c0 .403-4.077-.193-6.17-.118-2.306.082-6.827.548-6.778.159.041-1.3.256-2.63.275-4.13.028-2.163-.319-4.419-.062-6.564.011-.088.208-.057.207-.071 1.956-.108 3.868.171 5.633.157 2.172-.017 4.084.002 6.233-.239.158-.004.252.226.242.474-.121 3.114.679 9.966.42 10.332M8.515 2c1.71-.055 2.745 1.473 3.72 3.32-.841-.02-1.684-.005-2.523.009-1.387.024-2.774.048-4.16.075h-.13C6.16 3.622 6.912 2.054 8.516 2m9.314 5.381c-.005-.43-.155-1.273-.43-1.387-.002 0-.004 0-.007-.002a.428.428 0 0 0-.161-.081c-1.144-.315-2.307-.47-3.478-.545-.601-3.07-2.96-5.449-5.519-5.365-2.399.079-3.816 2.7-4.205 5.393-.858-.019-1.733-.03-2.527.141-.339.075-.537.318-.562.573 0 .003-.004.004-.005.007-.607 2.02-.662 4.636-.788 6.81-.148 2.493-.356 4.807.34 7.155.005.015.012.026.017.04.08.292.266.559.536.591 2.677.318 4.554.302 7.074.277 3.017-.03 5.982-.037 8.93-.832a.525.525 0 0 0 .221-.12c.07-.024.125-.056.137-.1.982-3.235.467-8.674.426-12.554" />
          </defs>
          <g fill="current"
             fill-rule="evenodd">
            <mask id="bag-b"
                  fill="#fff">
              <use href="#bag-a" />
            </mask>
            <use fill="current"
                 href="#bag-a" />
            <g fill="current"
               mask="url(#bag-b)">
              <path d="M0 0h18v23H0z" />
            </g>
          </g>
        </svg>
      </span>

      <span v-show="cart.lineItemCount > 0"
            class="cart-total">
        {{ cart.lineItemCount }}
      </span>
    </a>

    <div>
      <Transition name="overlay-effect"
                  appear>
        <div v-if="showSidebar"
             class="bx-custom-sidebar overlay" />
      </Transition>
      <OffCanvas :show-sidebar="showSidebar"
                 @sidebar-was-closed="showSidebar = $event">
        <template #default>
          <div class="offcanvas-header"
               @click="showSidebar = false">
            <svg xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 width="20"
                 height="20"
                 viewBox="0 0 24 24"><defs><path id="icons-default-arrow-head-left-a"
                                                 d="m12.5 7.9142 10.2929 10.293c.3905.3904 1.0237.3904 1.4142 0 .3905-.3906.3905-1.0238 0-1.4143l-11-11c-.3905-.3905-1.0237-.3905-1.4142 0l-11 11c-.3905.3905-.3905 1.0237 0 1.4142.3905.3905 1.0237.3905 1.4142 0L12.5 7.9142z" /></defs><use fill="current"
                                                                                                                                                                                                                                                                                               fill-rule="evenodd"
                                                                                                                                                                                                                                                                                               transform="matrix(0 1 1 0 .5 -.5)"
                                                                                                                                                                                                                                                                                               href="#icons-default-arrow-head-left-a" /></svg>
            <span>Weiter einkaufen</span>
          </div>

          <div class="offcanvas-content">
            <div class="row">
              <div class="col cart-heading">
                Warenkorb
              </div>
              <div v-if="cart.lineItemCount > 0"
                   class="col cart-count text-small">
                {{ cart.lineItemCount }} {{ getProductWording() }}
              </div>
            </div>

            <div v-if="cart.lineItemCount <= 0"
                 class="alert row">
              <span class="col-2">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     viewBox="0 0 24 24"><path fill="#fff"
                                               fill-rule="evenodd"
                                               d="M12 7c.5523 0 1 .4477 1 1s-.4477 1-1 1-1-.4477-1-1 .4477-1 1-1zm1 9c0 .5523-.4477 1-1 1s-1-.4477-1-1v-5c0-.5523.4477-1 1-1s1 .4477 1 1v5zm11-4c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0s12 5.3726 12 12zM12 2C6.4772 2 2 6.4772 2 12s4.4772 10 10 10 10-4.4772 10-10S17.5228 2 12 2z" /></svg>
              </span>
              <div class="col message">
                Dein Warenkorb ist leer
              </div>
            </div>

            <div v-else
                 class="line-items">
              <div v-for="lineItem in cart.lineItems"
                   :key="lineItem.id"
                   class="line-item row">
                <div class="col-4 line-item-image-wrapper">
                  <a :href="getURLFromBase('/detail/' + lineItem.id)"
                     class="line-item-image-link">
                    <img :src="lineItem.cover.thumbnails[0].url"
                         class="line-item-image">
                  </a>
                </div>
                <div class="col-4 line-item-details">
                  <a :href="getURLFromBase('/detail/' + lineItem.id)"
                     class="line-item-name-link col-4">
                    <div class="line-item-name">{{ getLineItemQuantity(lineItem) }}{{ lineItem.label }}</div>
                  </a>
                  <div class="col-4 line-item-price">
                    {{ convertToCurrency(lineItem.price.totalPrice) }}
                  </div>
                </div>
              </div>

              <div class="row offcanvas-summary">
                <div class="col">
                  Zwischensumme:
                </div>
                <div class="col price">
                  {{ cart.totalPrice }}*
                </div>
                <div class="col">
                  Versandkosten:<span class="text-small">({{ cart.shipping.name }})</span>
                </div>
                <div class="col price">
                  {{ cart.shipping.cost }}
                </div>
              </div>
              <div class="text-small disclaimer">
                * Preise inkl. MwSt. zzgl. Versandkosten
              </div>
            </div>

            <div class="offcanvas-cart-actions">
              <a :href="getURLFromBase('/checkout/confirm')"
                 class="btn"
                 title="Weiter zur Kasse">
                Weiter zur Kasse
              </a>

              <a :href="getURLFromBase('/checkout/cart')"
                 class="btn btn-light"
                 title="Warenkorb anzeigen">
                Warenkorb anzeigen
              </a>
            </div>
          </div>
        </template>
      </OffCanvas>
      <div />
    </div>
  </div>
</template>

<script>
import DropdownMenu from './components/DropdownMenu.vue'
import OffCanvas from './components/OffCanvas.vue'

const swAccessKey = 'SWSCMMPTDWFTETZNAELOY002OQ'
const urlBase = 'https://www.happinez.de'

export default {
  name: 'Cart',
  components: {
    DropdownMenu,
    OffCanvas
  },
  props: {
  },
  data () {
    return {
      swContextToken: this.getContextToken(),
      cart: {
        lineItemCount: 0,
        totalPrice: 0,
        lineItems: [],
        shipping: {
          name: '',
          cost: 0
        }
      },
      showDropdown: false,
      showSidebar: false
    }
  },
  mounted () {
    this.fetchCart()
  },
  methods: {
    getLineItemQuantity (lineItem) {
      return (lineItem.quantity >= 1) ? lineItem.quantity + 'x ' : ''
    },
    convertToCurrency (value) {
      return value?.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
    },
    getProductWording () {
      return this.cart.lineItemCount === 1 ? 'Produkt' : 'Produkte'
    },
    getURLFromBase (path) {
      return urlBase + path
    },
    getContextToken () {
      let token
      if (!import.meta.env.SSR) {
        token = document.cookie
          .split('; ')
          .find((row) => row.startsWith('sw-context-token='))
          ?.split('=')[1]
      }
      return token
    },
    async fetchCart () {
      const options = {
        method: 'GET',
        headers: new Headers({
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'sw-access-key': swAccessKey,
          'sw-context-token': this.swContextToken
        })
      }

      try {
        const response = await fetch(`${urlBase}/store-api/checkout/cart`, options)
        if (!response.ok) {
          throw response.status
        }
        const data = await response.json()
        this.populateCart(data)
      } catch (error) {
        console.log(error)
      }
    },
    populateCart (resp) {
      this.cart.lineItemCount = resp.lineItems.length
      this.cart.totalPrice = this.convertToCurrency(resp.price.positionPrice)
      this.cart.lineItems = resp.lineItems
      this.cart.shipping.name = resp.deliveries['0']?.shippingMethod?.name
      this.cart.shipping.cost = this.convertToCurrency(resp.deliveries['0']?.shippingCosts?.totalPrice)
    }
  }
}
</script>
